export enum QesCheckPagesEnum {
  AUTH_SELECTION_PAGE = 1,
  START_AUTHENTIFICATION_PAGE = 2,
  AUTHENTIFICATION_STARTED_PAGE = 3
}
